export default {
  index: [
    {
      path: '/usergzrb',
      component: resolve => require(['./usergzrbIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/user_gzrb/_router.js